<div class="tabbable__body rounded-top-right no-margin">
  
  <div class="sticky-header">
    <h3>Här kan du redigera standard frekvenstak</h3>
  </div>

  <app-woo-table [data]="defaultFrequencyLimits()" [debug]="false" [loaderTpl]="loader">
    <woo-table-column name="name" header="Namn"></woo-table-column>
    <woo-table-column name="impressions" header="Impressions">
      <ng-template let-cell>
          @if (!isEditingRow(cell.row)) {
            <span>{{ cell.row.impressions }}</span>
          } @else {
            <div class="input__container apply-input-container">
              <input
                class="in"
                name="row-{{ cell.row.id }}"
                [(ngModel)]="cell.row.impressions"
                [wooMinValidator]="1"
                [disabled]="!cell.row.editable"
              />
            </div>
          }
      </ng-template>
    </woo-table-column>
    <woo-table-column name="time_unit" header="Tidsenhet">
      <ng-template let-cell>
        {{ translateTimeUnit(cell.row.time_unit) }}
      </ng-template>
    </woo-table-column>
    <woo-table-column name="actions" header="Redigera">
      <ng-template let-cell>
        <div class="centered-block">
          @if (!isEditingRow(cell.row)) {
            <div class="align-cell-horizontal-center inline-flex ">
              <button
                [ngClass]="[
                  'status-badge',
                  'icon-margin-override',
                  cell.row.editable ? 'primary' : 'info'
                ]"
                (click)="setEditingRow(cell.row)"
                [disabled]="!cell.row.editable"
              >
                <span class="icon-edit icon__semi-medium"></span>
                @if (!cell.row.editable) {
                  <div class="hover-text">
                    {{ cell.row.name }} är ej redigerbar
                  </div>
                }
              </button>
            </div>
          } @else {
            <div class="align-cell-horizontal-center inline-flex ">
              <button
                class="status-badge success icon-margin-override status-badge-no-margin"
                (click)="save(cell.row)"
              >
                <span class="icon-check icon__semi-medium"></span>
                <div class="hover-text">Spara</div>
              </button>
              <button
                class="status-badge info icon-margin-override status-badge-no-margin padding-button-left"
                (click)="unsetEditingRow(cell.row)"
              >
                <span class="icon-close-x icon__semi-medium"></span>
                <div class="hover-text">Avbryt</div>
              </button>
            </div>
          }
        </div>
      </ng-template>
    </woo-table-column>
  </app-woo-table>

  <ng-template #loader let-data>
    @if (show.loading) {
      <dot-loader [large]="true"></dot-loader>
    }
  </ng-template>
</div>
